import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";
import { Node } from "slate";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";
import DataTable from "../Tables/tables";

class ActivityListPublic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      loading: true,
      currPage: 1,
      totalPages: 1,
      word: ""
    };

    this.error = this.error.bind(this);
    this.insertAction = this.insertAction.bind(this);
    this.allocateAction = this.allocateAction.bind(this);
    this.deleteAction = this.deleteAction.bind(this);
    this.changePage = this.changePage.bind(this);
    this.changeSearch = this.changeSearch.bind(this);
  }

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  };

  serialize = nodes => nodes.map(n => Node.string(n)).join("\n");

  componentDidMount() {
    this.pullActivities();
  }

  pullActivities = async () => {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    let obj = {
      user_id: this.props.user.user.id,
      word: this.state.word,
      type_id: [1, 3]
    };

    axios
      .post(`${URL.api}activity/activity/listBySchool`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` },
        params: {
          page: this.state.currPage
        }
      })
      .then(resp => {
        const list = resp.data.data.map(item => {
          if (item.description?.includes('[{"type"')) {
            item.description = this.serialize(JSON.parse(item.description));
          }

          if (item?.private === true) {
            item.private = "Sim";
          } else if (item?.private === false) {
            item.private = "Não";
          }

          return item;
        });

        this.setState(
          {
            list,
            totalPages: resp.data.meta.last_page,
            currPage: resp.data.meta.current_page
          },
          () => {
            this.state.list.forEach(obj => this.renameKey(obj, "name", "nome"));
            this.state.list.forEach(obj =>
              this.renameKey(obj, "description", "descrição")
            );
            this.state.list.forEach(obj =>
              this.renameKey(obj, "type_name", "tipo")
            );

            this.setState({
              loading: false
            });
          }
        );
      })
      .catch(err => {
        this.setState({
          loading: false
        });
        throw new Error(err);
      });
  };

  changeSearch = word => {
    this.setState({ word });
  };

  renameKey = (obj, oldKey, newKey) => {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  };

  insertAction = () => {
    this.props.history.push("/activity/create");
  };

  downloadFileAction = async activity => {
    if (!activity.file_link) {
      toastr.warning("Atenção", "A atividade não possui arquivo para download");
      return;
    }

    try {
      const response = await fetch(activity.file_link);
      if (!response.ok) {
        toastr.error("Erro", "Ocorreu um erro ao tentar baixar o arquivo");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = activity.file_name || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toastr.error("Erro", "Ocorreu um erro ao tentar baixar o arquivo");
    }
  };

  deleteAction = arrayRow => {
    for (const row of arrayRow) {
      let obj = {
        id: row
      };
      axios.post(`${URL.api}activity/activity/delete`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      });
    }

    // window.location.href = window.location.href; // função que atualiza a página após deleção
  };

  allocateAction = row => {
    this.props.history.push(`/activity/allocate/${row.id}`);
  };

  reportAction = row => {
    if (row.type_name.toUpperCase() === "TV") {
      this.props.history.push(`/activity/tv/report/${row.id}`);
    } else {
      toastr.warning(
        "Atenção",
        'Para ver relatórios sobre essa atividade, visite a sala em que ela foi alocada e a selecione na aba "Atividades"'
      );
    }
  };

  getSelected = selecteds => {
    this.setState({
      // selectedQuestions: selecteds
    });
  };

  changePage = page => {
    this.setState({ currPage: page }, () => this.pullActivities());
  };

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            {this.state.list ? (
              <div id="list">
                <DataTable
                  list={this.state.list}
                  path="/activity/view/"
                  title="Atividades Públicas"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "nome", denomination: "Nome" },
                    { name: "descrição", denomination: "Descrição" },
                    { name: "tipo", denomination: "Tipo" },
                    { name: "author", denomination: "Autor" }
                  ]}
                  // csv
                  insert
                  delete
                  insertAction={this.insertAction}
                  getSelected={this.getSelected}
                  action
                  btnEdit={false}
                  btnView
                  btnAllocate={false}
                  btnReport={false}
                  btnDownloadFile
                  allocateAction={this.allocateAction}
                  reportAction={this.reportAction}
                  deleteAction={this.deleteAction}
                  downloadFileAction={this.downloadFileAction}
                  changePage={this.changePage}
                  changeSearch={this.changeSearch}
                  currPage={this.state.currPage}
                  totalPages={this.state.totalPages}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        {/* <button onClick={this.sendList}>Criar</button> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityListPublic);
